export default __webpack_public_path__ + "static/media/logo-color.830a36d9.png";